import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Flex, Typography } from '@knockrentals/knock-shared-web-v2';
import { ImageDialog } from '../../../../../ImageDialog';
import { BrandColor } from './BrandColor';
import Logo from './Logo';
import Photos from './Photos';
import { IMAGE_DIALOG_TYPES } from '../../../../../constants';

const Branding = ({ brandColor, logos, photos, updateMarketingMedia }) => {
  const [imageDialogType, setImageDialogType] = useState(null);

  const images = {
    [IMAGE_DIALOG_TYPES.LOGO]: logos,
    [IMAGE_DIALOG_TYPES.PHOTOS]: photos,
  };

  const openImageDialog = (type) => () => {
    setImageDialogType(type);
  };

  const closeImageDialog = () => {
    setImageDialogType(null);
  };

  const updateImages = (newImages) => {
    updateMarketingMedia({ [imageDialogType]: newImages });
  };

  return (
    <Flex flexDirection="column" gap={24}>
      <Typography color="textSecondary" variant="subtitle1">
        Branding & Photos
      </Typography>

      <ImageDialog
        closeDialog={closeImageDialog}
        images={images[imageDialogType]}
        isOpen={Boolean(imageDialogType)}
        type={imageDialogType}
        updateImages={updateImages}
      />
      <Flex gap={24}>
        <Logo
          logos={logos}
          openImageDialog={openImageDialog(IMAGE_DIALOG_TYPES.LOGO)}
        />

        <BrandColor
          brandColor={brandColor}
          updateMarketingMedia={updateMarketingMedia}
        />

        <Photos
          photosCount={photos.length}
          openImageDialog={openImageDialog(IMAGE_DIALOG_TYPES.PHOTOS)}
        />
      </Flex>
    </Flex>
  );
};

Branding.propTypes = {
  brandColor: PropTypes.string,
  logos: PropTypes.arrayOf(
    PropTypes.shape({
      clUrl: PropTypes.string,
      thumbUrl: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      clUrl: PropTypes.string,
      thumbUrl: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  updateMarketingMedia: PropTypes.func,
};

export default Branding;
